import { render, staticRenderFns } from "./BASchoolsImport.vue?vue&type=template&id=07b28056&scoped=true&"
import script from "./BASchoolsImport.vue?vue&type=script&lang=ts&"
export * from "./BASchoolsImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b28056",
  null
  
)

export default component.exports